import { create } from "zustand";
// openModal("unique-modal-id");
const useModalStore = create((set, get) => ({
  modals: {}, // Store modals by ID
  openModal: (id) =>
    set((state) => ({
      modals: { ...state.modals, [id]: true },
    })),
  closeModal: (id) =>
    set((state) => ({
      modals: { ...state.modals, [id]: false },
    })),
  isModalVisible: (id) => get().modals[id] || false,
}));

export default useModalStore;
